import { DesigntimeComponent } from './DesigntimeComponent.js'
import componentHelpers from './componentHelpers.js'
import * as $ from 'jquery';

class InfoScale extends DesigntimeComponent {
    static staticName = "Info (Scale)";
    static staticId = "infoScale";

    contextContentUrl;

    constructor(identifyer) {
        super(identifyer, 1);

        this.values = {
            headerContinue: { value: "Continue" },
            textContinue: { value: "Your response indicates continue..." },
            imageurlContinue: { value: "placeholder.png", dontTranslate: true },

            headerEqual: { value: "You seem to have a hard time making up your mind" },
            textEqual: { value: "Your response indicates that it's equally important..." },
            imageurlEqual: { value: "placeholder.png", dontTranslate: true },

            headerChange: { value: "Change" },
            textChange: { value: "Your response indicates change..." },
            imageurlChange: { value: "placeholder.png", dontTranslate: true },

            imageclass: { value: "sid-image-circle", dontTranslate: true },
            buttontext: { value: "Next" }
        };

        this.params = {
            analysis: { key: "url:monthlySpending", value: 1 }
        };
    }

    getRuntimeView(context) {
        this.contextContentUrl = context.getContentUrl();
        this.eventBroker.subscribe("valueChangedEvent", this.onRuntimeChanged.bind(this));

        var $view = $("<div></div>");
        var $textbox = $("<div class='sid-question-text'></div>");
        $textbox.append("<h3>" + componentHelpers.mdToHtml(this.values.headerContinue.value) + "</h3>");
        $view.append($textbox);

        var $imagebox = $("<div class='sid-question-image'></div>");
        if (this.values.imageurlContinue.value) {
            $imagebox.append($("<img class='" + this.values.imageclass.value + "' src='" + this.contextContentUrl + this.values.imageurlContinue.value + "'>"));
            $view.append($imagebox);
        }

        $view.append("<p class='sid-placeholder-text'>" + this.values.textContinue.value + "</p>");

        return $view;
    }

    onRuntimeChanged(eventParams) {
        if (eventParams.id == this.id)
            return;

        for (var paramIndex in this.params) {
            if (this.params[paramIndex].key == eventParams.key) {
                this.params[paramIndex].value = eventParams.value;
            }
        }

        this.replaceText();
    }

    replaceText() {
        var newHeader = componentHelpers.mdToHtml(this.values.headerContinue.value);
        var newText = this.values.textContinue.value;
        var img = this.values.imageurlContinue.value;

        if (this.params.analysis.value == 2) {
            var newHeader = componentHelpers.mdToHtml(this.values.headerEqual.value);
            var newText = this.values.textEqual.value;
            var img = this.values.imageurlEqual.value;
        }

        if (this.params.analysis.value == 3) {
            var newHeader = componentHelpers.mdToHtml(this.values.headerChange.value);
            var newText = this.values.textChange.value;
            var img = this.values.imageurlChange.value;
        }

        var $frame = componentHelpers.getRtFrame(this.id);
        $frame.find("h3").html(newHeader);
        $frame.find("img").attr("src", this.contextContentUrl + img);
        $frame.find(".sid-placeholder-text").html(newText);
    }
}

export { InfoScale }
